export const generateWebToken = (alias: string) => {
  return btoa(`https://dev-null.c-b4.com/simplePush/${alias}`);
};

const TokenUtils = {
  generateWebToken,
};

export default TokenUtils;
